module.exports = __webpack_public_path__ + "img/artimin.71f1531d.png";